import { useEffect, useState } from "react";
import { getReports } from "../services/reportService"; 
import { IReportResponse } from "../Interfaces/IReportsInterface";

export function useReports() {
  const [data, setData] = useState<IReportResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await getReports();
        setData(res);
      } catch (err: any) {
        console.error("Erro ao carregar reports:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, loading, error };
}